import { FormItemsGroup, FormItemsGroupProps } from '@billy/design-system'

type DetailsListProps = FormItemsGroupProps

export const DetailsList = (props: DetailsListProps) => {
  return <FormItemsGroup {...props} />
}
